import Vue from 'vue'

export default class Bus {

    constructor()
    {
        this._bus = new Vue()
    }
    
    listener( event, callback )
    {
        return this._bus.$on(event, callback)
    }

    dispatchEvent( event, obj )
    { 
        this._bus.$emit(event, obj)
    }
}


// WEBPACK FOOTER //
// ./src/bus.js